var Breakpoint;
(function (Breakpoint) {
    Breakpoint["GLOBAL"] = "";
    Breakpoint["LG"] = "lg";
    Breakpoint["MD"] = "md";
    Breakpoint["SM"] = "sm";
    Breakpoint["XSM"] = "xsm";
})(Breakpoint || (Breakpoint = {}));
export default Breakpoint;
//# sourceMappingURL=breakpoint.js.map